'use client';

import React, { useState } from 'react';
import DevToolsTrigger from './components/DevToolsTrigger';
import { withDevTools, useDevTools } from './DevToolsProvider';
import DevToolsPopover from './components/DevToolsPopover';

export const DevTools = () => {
	const [isOpen, setIsOpen] = useState(false);
	const { isVisible, position } = useDevTools();

	const handleToggle = () => {
		setIsOpen((prev) => !prev);
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	// Don't render until hydration is complete (isVisible is null during SSR)
	// After hydration, respect the user's preference
	if (isVisible === null || isVisible === false) {
		return null;
	}

	return (
		<div>
			<DevToolsTrigger onClick={handleToggle} isActive={isOpen} position={position} />
			{isOpen && <DevToolsPopover onClose={handleClose} position={position} />}
		</div>
	);
};

export default withDevTools(DevTools);
